import { useMemo } from 'react';

import { useGetAllQueryParams } from '@entities/eventJournal/lib/hooks';
import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { useDebouncedValue } from '@shared/hooks';

const DATE_FROM = EventJournalQueries.dateFrom;
const DATE_TO = EventJournalQueries.dateTo;
const IGNORED = new Set(['period_picker']);

export const useIsEventsListQueryEnable = () => {
    const { params, adaptedQueryParams } = useGetAllQueryParams();

    const debouncedQuery = useDebouncedValue(adaptedQueryParams, 800);
    const isSettled = debouncedQuery === adaptedQueryParams;

    const hasDateKeysRaw = useMemo(() => DATE_FROM in params || DATE_TO in params, [params]);
    const hasBothDatesRaw = useMemo(() => {
        const df = String(params[DATE_FROM] ?? '').trim();
        const dt = String(params[DATE_TO] ?? '').trim();
        return df.length > 0 && dt.length > 0;
    }, [params]);
    const blockByDates = hasDateKeysRaw && !hasBothDatesRaw;

    const hasNonDateParamsRaw = useMemo(
        () =>
            Object.entries(params).some(([k, v]) => {
                if (k === DATE_FROM || k === DATE_TO) return false;
                if (IGNORED.has(k)) return false;
                return String(v ?? '').trim().length > 0;
            }),
        [params]
    );

    const enabled =
        isSettled && !blockByDates && (debouncedQuery.length > 0 || hasNonDateParamsRaw);

    const queryKey = useMemo(
        () => ['journalEvents', 'list', enabled ? debouncedQuery || '__raw__' : 'disabled'],
        [enabled, debouncedQuery]
    );

    // пока специально оставил лог
    // useEffect(() => {
    //     console.log('[journal]', {
    //         enabled,
    //         debouncedQuery,
    //         adaptedQueryParams,
    //         params,
    //         blockByDates,
    //         hasDateKeysRaw,
    //         hasBothDatesRaw,
    //         hasNonDateParamsRaw,
    //         isSettled,
    //     });
    // }, [
    //     enabled,
    //     debouncedQuery,
    //     adaptedQueryParams,
    //     params,
    //     blockByDates,
    //     hasDateKeysRaw,
    //     hasBothDatesRaw,
    //     hasNonDateParamsRaw,
    //     isSettled,
    // ]);

    return {
        enabled,
        debouncedQuery,
        queryKey,
    };
};
